import React, { useState } from "react";
import SubHead from "../SubHead";
import editImg from "./../../../assets/img_upload_edit.jpg";

const Upload = () => {
    return (
        <>
            <SubHead title="안전보건" eng="SAFETY"></SubHead>
            <main className="sub-contents">
                <div className="inner">

                    <h3 className="board-upload-sbj">작성하기</h3>

                    <div className="board-upload-table">
                        <table className="tbl_upload">
                            <colgroup>
                                <col width="15%" />
                                <col width="35%" />
                                <col width="15%" />
                                <col width="35%" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>
                                        <label>게시글 유형</label>
                                    </th>
                                    <td colSpan={3}>
                                        <span>
                                            <input type="radio" name="write" id="normal_write" />
                                            <label htmlFor="normal_write">일반게시글</label>
                                        </span>
                                        <span>
                                            <input type="radio" name="write" id="secret_write" />
                                            <label htmlFor="secret_write">비밀게시글</label>
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <label htmlFor="upload-name">이름</label>
                                    </th>
                                    <td>
                                        <input type="text" className="text_nor w100" id="upload-name" />
                                    </td>
                                    <th>
                                        <label htmlFor="upload-email">이메일</label>
                                    </th>
                                    <td>
                                        <input type="email" className="text_nor w100" id="upload-email" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <label htmlFor="upload-cell">핸드폰</label>
                                    </th>
                                    <td>
                                        <input type="text" className="text_nor w100" id="upload-cell" />
                                    </td>
                                    <th>
                                        <label htmlFor="upload-phone">일반전화</label>
                                    </th>
                                    <td>
                                        <input type="text" className="text_nor w100" id="upload-phone" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <label>내용입력</label>
                                    </th>
                                    <td colSpan={3}>
                                        <div className="f-row">
                                            <input type="text" className="text_nor f-grow" />
                                            <span className="f-shrink">
                                                <label>
                                                    <input type="checkbox" /> 이 글을 상단에 고정합니다.
                                                </label>
                                            </span>
                                        </div>
                                        <div className="edit_box">
                                            <img src={editImg} alt="" />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <label htmlFor="upload-edit">첨부파일</label>
                                    </th>
                                    <td colSpan={3}>
                                        <div className="f-row">
                                            <input type="file" className="text_nor f-grow" id="upload-edit" />
                                            <button type="button" className="btn_nor md f-shrink black">
                                                삭제
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div className="password-alt">
                            <p>
                                비밀게시글 처리결과 확인을 위해서는 '비밀번호'가 반드시 필요합니다. <br />
                                정보를 먼저 작성하신 후 계속해서 이용해 주시기 바랍니다.
                            </p>
                        </div>

                        <table className="tbl_upload">
                            <colgroup>
                                <col width="15%" />
                                <col width="35%" />
                                <col width="15%" />
                                <col width="35%" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>
                                        <label htmlFor="upload-pwd">비밀번호</label>
                                    </th>
                                    <td colSpan={3}>
                                        <input type="password" className="text_nor" id="upload-pwd" placeholder="비밀번호 (8자리이상 영문/숫자/특수문자 혼합)" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <label htmlFor="upload-pwd2">비밀번호 확인</label>
                                    </th>
                                    <td colSpan={3}>
                                        <input type="password" className="text_nor" id="upload-pwd2" placeholder="비밀번호확인" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="board-upload-btns">
                        <button type="button" className="btn_nor lg gray-line">
                            취소
                        </button>
                        <button type="button" className="btn_nor lg red-line">
                            등록
                        </button>
                    </div>
                </div>
            </main>
        </>
    );
};

export default Upload;
